const PROJECT_ID = 'o73n4z5y'
const DATASET = 'production'
const API_VERSION = '2024-01-01'

export const client = {
  fetch(query, params = {}) {
    const encodedQuery = encodeURIComponent(query)
    const paramParts = Object.entries(params).map(
      ([k, v]) => `$${k}=${encodeURIComponent(JSON.stringify(v))}`
    )
    const qs = [encodedQuery ? `query=${encodedQuery}` : '', ...paramParts]
      .filter(Boolean)
      .join('&')
    const url = `https://${PROJECT_ID}.apicdn.sanity.io/v${API_VERSION}/data/query/${DATASET}?${qs}`
    return fetch(url)
      .then((r) => r.json())
      .then((d) => d.result)
  },
}

export function urlFor(image) {
  if (!image || !image.asset || !image.asset._ref) return ''
  // ref: image-{id}-{width}x{height}-{format}
  const parts = image.asset._ref.split('-')
  const format = parts.pop()
  const dimensions = parts.pop()
  const id = parts.slice(1).join('-')
  return `https://cdn.sanity.io/images/${PROJECT_ID}/${DATASET}/${id}-${dimensions}.${format}`
}

export function blocksToHtml(blocks) {
  if (!blocks || !blocks.length) return ''
  var html = ''
  var prevWasImage = false
  blocks.forEach(function (block) {
    var isImage = block._type === 'image'
    var rendered

    if (isImage) {
      var url = urlFor(block)
      if (!url) return
      var alt = block.alt || ''
      rendered = '<img class="info-images" src="' + url + '" alt="' + alt + '">'
    } else if (block._type === 'block') {
      var defs = {}
      if (block.markDefs) {
        block.markDefs.forEach(function (def) { defs[def._key] = def })
      }
      rendered = block.children
        .map(function (span) {
          var text = span.text
          if (span.marks && span.marks.length) {
            span.marks.forEach(function (mark) {
              if (mark === 'strong') text = '<strong>' + text + '</strong>'
              else if (mark === 'em') text = '<em>' + text + '</em>'
              else if (mark === 'highlight') text = '<span class="about-highlight">' + text + '</span>'
              else if (defs[mark] && defs[mark]._type === 'link') {
                text = '<a href="' + defs[mark].href + '" target="_blank">' + text + '</a>'
              }
            })
          }
          return text
        })
        .join('')
    } else {
      return
    }

    if (html && !prevWasImage) {
      html += '<br><br>'
    }
    html += rendered
    prevWasImage = isImage
  })
  return html
}
